import { Component, Inject, Injector, ChangeDetectionStrategy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { jkRestReturn } from 'jk-service';
import { MaterialModule } from 'jk-service';
import { SyskaService, templateUrlConfigSys } from '../_service_sys';
import { Syska } from '../_entity_sys';
import { JkDialogEditComponent } from 'jk-service';
import { JackBaseComponentModule } from "jk-service";


@Component({
  selector: 'app-syska-edit',
  templateUrl: templateUrlConfigSys.syska,
  styleUrls: [],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [JackBaseComponentModule, MaterialModule],
})

export class SyskaEditComponent extends JkDialogEditComponent<SyskaService, Syska> {
  override srv!: SyskaService;
  constructor(
    inject: Injector,
    public override dialogRef: MatDialogRef<SyskaEditComponent>,
    @Inject(MAT_DIALOG_DATA)
    public override data: jkRestReturn
  ) {
    super(inject, dialogRef, data);
  }


}
